import http from '@/api/http';

export type PortalDocumentType = 'arrivalUpdate' | 'releaseRequest' | 'loi';

export interface GeneratedDocumentFile {
  filename: string;
  /** Continutul PDF-ului codificat base64. */
  base64: string;
}

export const documentsApi = {
  /**
   * Genereaza un document pentru un B/L. Documentul este produs de aplicatia principala
   * (aceiasi generatori ca in pagina Bills) si returnat ca PDF base64. Backend-ul verifica
   * faptul ca B/L-ul apartine unui client asociat contului curent.
   */
  generate: async (billId: number, documentType: PortalDocumentType): Promise<GeneratedDocumentFile[]> => {
    const response = await http.post('/documents/generate', { billId, documentType });
    return (response.data?.data?.files as GeneratedDocumentFile[]) ?? [];
  },
};

/** Transforma un PDF base64 intr-un blob si declanseaza descarcarea in browser. */
export function downloadBase64Pdf(file: GeneratedDocumentFile): void {
  const byteChars = atob(file.base64);
  const bytes = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    bytes[i] = byteChars.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = file.filename || 'document.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
